// extracted by mini-css-extract-plugin
export var productImage = "_wk-0";